module.exports = __webpack_public_path__ + "img/canada-infectious-diseases-female.4078688e.png";